/**
 * Firmware (Phase H): per-charger timeline + fleet rollouts.
 */

import { enc, ocppRequest } from './ocppApi';
import type {
  CreateRolloutBody,
  CreateRolloutResponse,
  GetFirmwareInventoryResponse,
  GetFirmwareTimelineResponse,
  ListRolloutsResponse,
  PatchRolloutBody,
} from '../models';

export const fetchFirmwareInventory = () =>
  ocppRequest<GetFirmwareInventoryResponse>({
    method: 'GET',
    path: 'firmware/inventory',
  });

export const fetchFirmwareTimeline = (chargerId: string, limit?: number) =>
  ocppRequest<GetFirmwareTimelineResponse>({
    method: 'GET',
    path: `firmware/${enc(chargerId)}/timeline`,
    query: { limit },
  });

export const listRollouts = () =>
  ocppRequest<ListRolloutsResponse>({
    method: 'GET',
    path: 'firmware/rollouts',
  });

export const createRollout = (body: CreateRolloutBody) =>
  ocppRequest<CreateRolloutResponse>({
    method: 'POST',
    path: 'firmware/rollouts',
    body,
  });

export const patchRollout = (groupId: number, body: PatchRolloutBody) =>
  ocppRequest<{ success: boolean }>({
    method: 'PATCH',
    path: `firmware/rollouts/${enc(groupId)}`,
    body,
  });
